import { render, staticRenderFns } from "./JobPost.vue?vue&type=template&id=2ab5d77f&scoped=true"
import script from "./JobPost.vue?vue&type=script&lang=js"
export * from "./JobPost.vue?vue&type=script&lang=js"
import style0 from "./JobPost.vue?vue&type=style&index=0&id=2ab5d77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5d77f",
  null
  
)

export default component.exports